import { PageRouteBuilder } from "@common/route/page-route-builder";
import { TriggerSurveySchedulerComponent } from "./trigger-survey-scheduler.component";

export const triggerSurveySchedulerRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-trigger-survey-scheduler", TriggerSurveySchedulerComponent)
    .requiresLogin()
    .atUrl("/tools/trigger-survey-scheduler")
    .withTitle("Trigger Survey Scheduler Checks")
    .build();
